import Marty from "marty";
import router from "./router";

let App = Marty.createApplication(function App(opts) {
    Marty.HttpStateSource.removeHook("parseJSON");

    //This will automatically resolve the response to JSON
    Marty.HttpStateSource.addHook({
        id: "parseBody",
        priority: 1,
        after(res) {
            return res.json();
        }
    });

    this.data = {};

    if (opts && opts.req) {
        //This is for passing the shopify data into the gateway store.
        if (opts.req.body && opts.req.body.x_reference) {
            this.data.gateway = opts.req.body;
        }
    }

    this.router = router;
    this.register(require("../sources"));
    this.register(require("../actions"));
    this.register(require("../queries"));
    this.register(require("../stores"));
});

export default App;



/** WEBPACK FOOTER **
 ** ./app/config/app.js
 **/